import { Link } from "react-router-dom";
import { ArrowRight, Scale, FileCheck2 } from "lucide-react";
import { LEGAL, LEGAL_DOCS } from "@/legal/config";

export default function LegalCenter() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16" data-testid="legal-center-page">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#FF9F0A]/40 bg-[#FF9F0A]/10">
        <Scale className="h-3.5 w-3.5 text-[#FF9F0A]" />
        <span className="text-xs font-semibold text-[#FF9F0A] uppercase tracking-widest">Legal Center · v{LEGAL.version}</span>
      </div>
      <h1 className="mt-4 font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl">Clear rules for a global stage<span className="text-[#FF3B30]">.</span></h1>
      <p className="mt-4 max-w-2xl text-neutral-400 leading-relaxed">Every document that governs VISMARKS, in plain English. Effective {LEGAL.effective}. Operated by {LEGAL.entity}, {LEGAL.entityDescription}; governed by {LEGAL.governingLaw}.</p>
      <div className="mt-10 grid sm:grid-cols-2 gap-3">
        {LEGAL_DOCS.map((d, i) => (
          <Link key={d.slug} to={d.path} data-testid={`legal-center-${d.slug}`}
            className="group rounded-2xl border border-white/10 bg-[#121212] p-5 hover:border-white/30 hover:bg-[#161616] transition-colors">
            <div className="text-[10px] uppercase tracking-widest text-neutral-500">0{i + 1}</div>
            <div className="mt-1 flex items-center justify-between gap-3">
              <h2 className="text-base md:text-lg font-black tracking-tight text-white">{d.title}</h2>
              <ArrowRight className="h-4 w-4 text-neutral-500 group-hover:text-white group-hover:translate-x-0.5 transition-all" />
            </div>
            <p className="mt-1.5 text-sm text-neutral-400">{d.blurb}</p>
          </Link>
        ))}
        <Link to="/legal" data-testid="legal-center-notice" className="group rounded-2xl border border-dashed border-white/10 p-5 hover:border-white/30 transition-colors">
          <div className="flex items-center gap-2 text-white font-bold"><FileCheck2 className="h-4 w-4 text-[#FF9F0A]" /> Legal Notice & imprint</div>
          <p className="mt-1.5 text-sm text-neutral-400">The plain-English "no guarantee of sales" notice and company details.</p>
        </Link>
      </div>
    </div>
  );
}
